import React from 'react';
import CallEventCard from '../call_event_card';

// Inline chat card for a mentor-initiated call suggestion. Mentors see a
// confirmation that the suggestion was sent; patients see the invitation with
// actions to request an immediate call or schedule one for later. The actions
// are hidden once the suggestion has been addressed (a call was created after
// it) or superseded by a newer suggestion.
export default function CallSuggestionCard({
  isMentor,
  mentorFirstName,
  patientFirstName,
  actionable = false,
  onCallNow,
  onSchedule,
}) {
  if (isMentor) {
    return (
      <CallEventCard
        title='You suggested a call'
        description={`We sent ${
          patientFirstName || 'your mentee'
        } a text and added this card to the chat so they can start a call now or schedule one for later.`}
        tone='waiting'
      />
    );
  }

  const mentorName = mentorFirstName || 'your mentor';

  return (
    <CallEventCard
      title={`${mentorFirstName || 'Your mentor'} suggested a call`}
      description={`${
        mentorFirstName || 'Your mentor'
      } thinks a phone call could help. Your phone number is never shared with ${mentorName}. Start one now or schedule a time that works for you.`}
      tone='waiting'
      onAccept={actionable && typeof onCallNow === 'function' ? onCallNow : undefined}
      acceptButtonLabel='Request a call now'
      secondaryAction={
        actionable && typeof onSchedule === 'function'
          ? { label: 'Schedule for later', onClick: onSchedule }
          : undefined
      }
    />
  );
}
